import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ProductVariantDefinitionService } from 'app/services/models/product-variant-definition.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-product-variant-definition',
  templateUrl: './product-variant-definition.component.html',
  styleUrls: ['./product-variant-definition.component.scss'],
  encapsulation:ViewEncapsulation.None
})
export class ProductVariantDefinitionComponent implements OnInit {
  @Input() id?: number;
  productVariantForm: FormGroup;

  variantTypes: any[] = [
    { id: 1, name: 'Seçmeli' },
    { id: 2, name: 'Kontrol' },
    { id: 3, name: 'Metin' }
  ];

  constructor(
    private productVariantDefinitionService: ProductVariantDefinitionService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    public ngbModal: NgbActiveModal
  ) {
  }

  async ngOnInit() {
    this.productVariantForm = this.fb.group({
      name: ['', [Validators.required, Validators.maxLength(100), Validators.minLength(2)]],
      secondName: [''],
      variantType: ['', [Validators.required]],
      isActive: [true]
    });
    console.log(this.id);
    if(this.id != null){
      await this.getByIdProductDefinition(this.id);
    }
  }

  async getByIdProductDefinition(id){
    const data = await this.productVariantDefinitionService.getByIdProductVariantDefinition(id);
    console.log(data);
    if(data != null){
      this.productVariantForm.patchValue({
        name:data.name,
        secondName:data.secondName,
        variantType:data.variantType,
        isActive:data.isActive
      })
    }
  }

  async createProductVariantDefinition() {
    const formData = this.productVariantForm.value;
    let response = await this.productVariantDefinitionService.createProductVariantDefinition({
      name:formData.name,
      secondName:formData.secondName,
      variantType:Number(formData.variantType),
      isActive:formData.isActive
    });
    console.log(response);
    if (response.status) {
      this.toastr.success(response.message);
      this.closeModal(true);
    } else {
      this.toastr.error(response.message);
    }
  }

  async updateProductVariantDefinition() {
    const formData = this.productVariantForm.value;
    let response = await this.productVariantDefinitionService.updateProductVariantDefinition({
      id:this.id,
      name:formData.name,
      secondName:formData.secondName,
      variantType:Number(formData.variantType),
      isActive:formData.isActive
    });
    console.log(response);
    if (response.status) {
      this.toastr.success(response.message);
      this.closeModal(true);
    } else {
      this.toastr.error(response.message);
    }
  }
  
  closeModal(result: boolean = false) {
    this.ngbModal.close(result);
  }
}